var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvexiaLogoRed = function SvgEvexiaLogoRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EvexiaLogoRed_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.982 18.835c-.872 0-1.306-.434-1.306-1.306V6.585c0-.871.434-1.306 1.306-1.306h6.867c.667 0 1 .32 1 .962 0 .667-.333 1-1 1h-5.807v3.732h5.383c.668 0 1.001.328 1.001.982 0 .653-.334.981-1 .981h-5.384v3.942h5.807c.667 0 1 .328 1 .981 0 .654-.333.982-1 .982h-6.867v-.006ZM43.866 18.99c-.642 0-1.116-.34-1.424-1.02l-3.059-7.097c-.18-.423-.182-.794-.008-1.116.174-.32.521-.48 1.048-.48.295 0 .533.068.712.202.18.135.34.387.48.76l2.31 5.77 2.383-5.79c.14-.358.306-.605.491-.74.185-.134.44-.201.76-.201.41 0 .698.16.866.479.166.32.16.687-.02 1.096l-3.114 7.119c-.284.678-.757 1.018-1.425 1.018ZM54.924 19.029c-1.065 0-1.98-.2-2.75-.597a4.232 4.232 0 0 1-1.778-1.694c-.418-.732-.625-1.595-.625-2.596 0-.973.202-1.828.606-2.557a4.45 4.45 0 0 1 1.673-1.721c.713-.418 1.523-.626 2.434-.626 1.335 0 2.389.424 3.163 1.27.776.847 1.163 2 1.163 3.463 0 .474-.308.712-.922.712H52.08c.18 1.68 1.141 2.52 2.885 2.52.334 0 .71-.041 1.125-.125.417-.084.81-.227 1.183-.432.333-.194.614-.253.846-.183.23.07.396.208.491.413.096.204.11.431.04.681-.07.25-.253.465-.547.645-.449.283-.965.49-1.548.625a7.377 7.377 0 0 1-1.632.202Zm-.347-8.153c-.707 0-1.276.218-1.71.653-.435.434-.699 1.026-.788 1.77h4.73c-.051-.783-.267-1.383-.645-1.798-.379-.418-.906-.625-1.587-.625ZM61.597 18.934c-.283 0-.516-.082-.7-.242a.813.813 0 0 1-.29-.625c-.005-.255.099-.524.317-.807l2.656-3.27-2.462-3.039c-.23-.283-.34-.552-.328-.807a.854.854 0 0 1 .297-.625c.185-.16.42-.241.7-.241.295 0 .542.05.741.154.2.103.381.263.547.48l1.884 2.422 1.904-2.423c.18-.219.364-.378.558-.48.193-.103.428-.153.712-.153.294 0 .532.084.712.25.18.164.272.378.277.633.006.258-.106.527-.336.807l-2.459 3.023L69 17.26c.23.269.34.532.328.788a.877.877 0 0 1-.297.633c-.185.166-.426.25-.72.25-.514 0-.937-.21-1.27-.634l-2.098-2.635-2.077 2.635a1.902 1.902 0 0 1-.539.471c-.193.11-.434.166-.729.166ZM72.924 7.508c-.448 0-.799-.112-1.048-.336-.25-.224-.376-.536-.376-.934 0-.41.126-.723.376-.942.25-.218.6-.328 1.048-.328.948 0 1.425.424 1.425 1.27 0 .847-.477 1.27-1.425 1.27Zm0 11.462c-.384 0-.678-.115-.886-.345-.204-.23-.308-.552-.308-.962v-7.056c0-.872.398-1.307 1.191-1.307.808 0 1.212.435 1.212 1.306v7.057c0 .41-.104.732-.309.962-.202.23-.504.345-.9.345ZM80.02 19.029c-.678 0-1.284-.132-1.816-.395a3.16 3.16 0 0 1-1.25-1.069 2.675 2.675 0 0 1-.452-1.52c0-.692.18-1.239.538-1.642.359-.404.942-.696 1.75-.875.807-.18 1.89-.27 3.25-.27h.672v-.403c0-.642-.14-1.102-.423-1.385-.283-.283-.757-.423-1.424-.423-.373 0-.774.045-1.203.134-.43.09-.88.244-1.357.463-.309.14-.564.157-.769.048a.83.83 0 0 1-.412-.52 1.067 1.067 0 0 1 .04-.72c.095-.244.291-.423.585-.538a8.541 8.541 0 0 1 3.194-.673c1.371 0 2.392.317 3.059.953.667.634 1 1.618 1 2.953v4.615c0 .821-.372 1.23-1.115 1.23-.757 0-1.136-.409-1.136-1.23v-.424c-.218.527-.563.94-1.037 1.24-.477.3-1.04.451-1.694.451Zm.5-1.654c.628 0 1.15-.219 1.567-.654.418-.434.625-.986.625-1.654v-.423h-.653c-1.206 0-2.041.092-2.51.277-.468.186-.7.522-.7 1.01 0 .423.148.768.443 1.037.291.272.7.407 1.228.407Z",
    fill: "#F95A59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.746 10.545c-.55-2.75-4.116-4.195-6.41-1.708C16.491 2.495 24.889 2.871 24.889 12c0 6.622-5.386 12-12.037 12a12.042 12.042 0 0 1-9.283-4.363c4.209 1.467 7.212.825 9.94-.877 2.492-1.545 6.897-4.946 6.238-8.215Z",
    fill: "#F95A59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27 8.394a1.29 1.29 0 0 0-.133.115C5.893 9.614 5.35 11.54 6.58 13.64a8.054 8.054 0 0 0 1.435 1.75c.46.429.976.866 1.514 1.284a30.647 30.647 0 0 0 2.95 2.024c-1.192.502-2.347.757-3.435.805a7.976 7.976 0 0 1-2.321-.227c-3.931-2.03-3.9-7.366.546-10.882Z",
    fill: "url(#EvexiaLogoRed_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.851 9.451C11.284 7.124 8.806 7.15 7.27 8.394c-4.447 3.516-4.477 8.852-.544 10.879-2.4-.603-4.284-2.305-5.206-4.576-.58-1.421-.785-3.061-.51-4.791.653-1.84 1.676-3.14 2.865-3.934 2.994-1.98 7.051-.72 8.977 3.48Z",
    fill: "url(#EvexiaLogoRed_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.851 0c-1.873 0-3.645.429-5.223 1.189a12.109 12.109 0 0 0-5.518 5.4 11.305 11.305 0 0 0-1.102 3.317c.654-1.84 1.677-3.14 2.866-3.934 2.991-1.982 7.048-.723 8.977 3.48 1.514-5.168 4.579-6.612 8.737-5.706A12.01 12.01 0 0 0 12.85 0Z",
    fill: "#F95A59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "EvexiaLogoRed_svg__b",
    x1: 12.073,
    y1: 19.104,
    x2: 4.264,
    y2: 11.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F95A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#F55958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#E85453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#D44D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EvexiaLogoRed_svg__c",
    x1: 2.508,
    y1: 17.175,
    x2: 9.219,
    y2: 5.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F95A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#F55958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#E85453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#D44D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4443"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "EvexiaLogoRed_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.888)",
    d: "M0 0h84.112v24H0z"
  })))));
};
export default SvgEvexiaLogoRed;